var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticClass:"app"},[_c('v-main',[_c('router-view')],1),_c('ForcePasswordModal',{attrs:{"visible":_vm.shouldForcePasswordChange},on:{"updated":_vm.handlePasswordUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }